import LottoNav from "../LottoNav";
import {lottoMenus} from "../../constants/nav";
import React from "react";


const Lotto6Nav = () => <LottoNav menus={lottoMenus('lottery6')}/>

export default Lotto6Nav;